import { UnknownAction } from "@reduxjs/toolkit";

import { authSliceActions } from "../auth";

// const SESSION_DURATION_MS = 1 * 60 * 1000; // TEST: 1 minuto
// const WARN_BEFORE_MS = 10 * 1000; // TEST: 10 segundos
const SESSION_DURATION_MS = 60 * 60 * 1000;
const WARN_BEFORE_MS = 5 * 60 * 1000;
const { logout } = authSliceActions;

let warningTimer: ReturnType<typeof setTimeout> | null = null;
let logoutTimer: ReturnType<typeof setTimeout> | null = null;
let activeNotification: Notification | null = null;
let visibilityHandler: (() => void) | null = null;

export function clearTimers() {
  if (warningTimer) {
    clearTimeout(warningTimer);
    warningTimer = null;
  }
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
}

export function dismissNotification() {
  if (activeNotification) {
    activeNotification.close();
    activeNotification = null;
  }
}

export function removeVisibilityListener() {
  if (visibilityHandler) {
    document.removeEventListener("visibilitychange", visibilityHandler);
    visibilityHandler = null;
  }
}

export function sendWarningNotification() {
  if (typeof Notification === "undefined" || Notification.permission !== "granted") return;
  dismissNotification();
  activeNotification = new Notification("Sessão expirando", {
    body: "Sua sessão expira em 5 minutos. Volte à página para renová-la.",
    icon: "/favicon.ico",
    tag: "session-expiry-warning",
    requireInteraction: true
  });
}

export function scheduleLogout(dispatch: (action: UnknownAction) => void) {
  clearTimers();
  console.log("[watchdog] scheduleLogout iniciado — warning em 50s, logout em 60s");
  warningTimer = setTimeout(sendWarningNotification, SESSION_DURATION_MS - WARN_BEFORE_MS);
  logoutTimer = setTimeout(() => {
    dismissNotification();
    dispatch(logout());
  }, SESSION_DURATION_MS);
}

export function registerVisibilityHandler(dispatch: (action: UnknownAction) => void) {
  removeVisibilityListener();

  visibilityHandler = () => {
    if (document.hidden) {
      scheduleLogout(dispatch);
    } else {
      clearTimers();
      dismissNotification();
    }
  };

  document.addEventListener("visibilitychange", visibilityHandler);
}
